import { render } from "./SetToken.vue?vue&type=template&id=5643d667"
import script from "./SetToken.vue?vue&type=script&lang=js"
export * from "./SetToken.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__